// Localização: ./src/hooks/usePacienteList.js

import { useEffect } from 'react';
import { usePacientes } from './usePacientes'; // Importa o hook base

/**
 * Hook customizado para gerenciar o estado e o carregamento automático da lista de pacientes.
 * Deve ser usado apenas por componentes que precisam da lista completa na montagem (ex: PacienteList).
 */
export const usePacienteList = () => {
    // Reutiliza todas as funções do hook base
    const hookData = usePacientes();

    const { fetchPacientes } = hookData;

    // 💡 REINTRODUZ O useEffect de carregamento da lista AQUI
    useEffect(() => {
        // Esta função chamará o fetchPacientes do hookData
        fetchPacientes();
    }, [fetchPacientes]); 

    return hookData;
};